import SharedComponents from '@webcarelbj/shared-components'
import BedmatPick from './components/BedmatPick/BedmatPick.vue'
import { version } from '../package.json'

export default {
  install(
    app,
    options = {
      apiDomainDecision: ''
    }
  ) {
    try {
      if (!options.apiDomainDecision) {
        throw new Error('apiDomainDecision missing')
      }

      if (!app.config.globalProperties.$sharedComponentsInitialized) {
        app.use(SharedComponents)
      }

      //  Set global const
      app.provide('BEDMATPICK_API_DOMAIN_DECISION', options.apiDomainDecision)

      //  Main component
      app.component('BedmatPick', BedmatPick)

      //  Set state so other apps can react to it
      app.config.globalProperties.$bedmatpickPluginInitialized = true

      console.group(
        '%cpflege.de %cBedmatPick',
        'background-color: #f1f7f7; color: #005b85; font-weight: 900',
        'background-color: #f1f7f7; color: #ed6976; font-style: italic; font-weight: 400'
      )
      console.info(`%cVersion: %c${version}`, 'color: #005b85', 'font-weight: 900')
      console.info('%cRun by: 🦄', 'color: hotpink')
      console.groupEnd()
    } catch (error) {
      console.error(`BedmatPick: Error while initializing plugin: ${error.message}.`)
    }
  }
}
